import psl_events from './libs/psl_events.js';

let _events=new psl_events.class();

let _data={
	section:0,
	submenu:0,
};

const state={
	reinit:()=>{
		_data.section=0;
		_data.submenu=0;
		_events.emit('reinit');
		_events.emit('section',[_data.section]);
		_events.emit('submenu',[_data.submenu]);
	},
	events:_events,
	get section(){
		return _data.section;
	},
	set section(v = 0){
		if(_data.section === v) return;
		_data.section=v;
		_data.submenu=0;
		_events.emit('section',[_data.section]);
		return _data.section;
	},
	get submenu(){
		return _data.submenu;
	},
	set submenu(v = 0){
		if(_data.submenu === v) return;
		_data.submenu=v;
		_events.emit('submenu',[_data.submenu]);
		return _data.submenu;
	}
}

export default state;
